import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var uploadAssetTypes = {
  VIDEO_URL: 'video',
  IMAGE: 'image',
  INLINE_SVG: 'inlinesvg',
  GENERATED_SVG: 'generatedsvg',
  FILE: 'file',
  GIF: 'gif'
};
uploadAssetTypes.ALL = _valuesInstanceProperty(_).call(_, uploadAssetTypes);
export default uploadAssetTypes;
//# sourceMappingURL=upload-asset-types.js.map